import Vue from 'vue';

Vue.filter('currency', (val: number | string) => {
	if (!val) return '';
	const value = typeof val === 'string' ? parseFloat(val) : val;
	const formatter = new Intl.NumberFormat('it-IT', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
	return formatter.format(value);
});


Vue.filter('year', (val: string | number | Date) => {
	if (!val && val !== 0) return '';

	const parseDateString = (input: string): Date | null => {
		const [day, month, year] = input.split('/');
		if (day && month && year) {
			return new Date(Number(year), Number(month) - 1, Number(day));
		}

		const parsed = Date.parse(input);
		return Number.isNaN(parsed) ? null : new Date(parsed);
	};

	let date: Date | null = null;

	if (val instanceof Date) {
		date = val;
	} else if (typeof val === 'number') {
		date = new Date(val);
	} else if (typeof val === 'string') {
		date = parseDateString(val);
	}

	if (!date || Number.isNaN(date.getTime())) return '';
	return date.getFullYear();
});
